import publicRoutes from './public';
import merchantRoutes from './merchant';
import adminRoutes from './adminRoutes';

export default [
  ...publicRoutes,
  ...merchantRoutes,
  ...adminRoutes,

  [`^/?testing/wallet-qr/?$`, {
    title: 'Wallet QR testing',
    main: require('../../../components/pages/Testing/WalletQR'),
  }],
];
